import { useQuery } from '@tanstack/react-query';
import { registration } from '@/api';
import { useTenantApi } from '@/account/hook/useTenantApi';

export function useDaysQuery(eventId: string) {
  const { createTenantAdminApiRequest, isLoaded } = useTenantApi();

  return useQuery(
    [registration.daysQueryKey, eventId],
    async () => {
      const result = await registration.getDays(createTenantAdminApiRequest)(eventId);
      return result.items;
    },
    { enabled: isLoaded }
  );
}
